module.exports = __webpack_public_path__ + "static/media/mountain.5f651a8f.svg";